module.exports = __webpack_public_path__ + "static/img/um_logo.c7911bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/um_logo.svg
// module id = MRng
// module chunks = 1